/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiSanctionType } from './ApiSanctionType';
import {
    ApiSanctionTypeFromJSON,
    ApiSanctionTypeFromJSONTyped,
    ApiSanctionTypeToJSON,
    ApiSanctionTypeToJSONTyped,
} from './ApiSanctionType';

/**
 * 
 * @export
 * @interface ApiScreeningTestCase
 */
export interface ApiScreeningTestCase {
    /**
     * 
     * @type {string}
     * @memberof ApiScreeningTestCase
     */
    screenableText: string;
    /**
     * 
     * @type {ApiScreeningTestCaseScreenableTextTypeEnum}
     * @memberof ApiScreeningTestCase
     */
    screenableTextType: ApiScreeningTestCaseScreenableTextTypeEnum;
    /**
     * 
     * @type {ApiSanctionType}
     * @memberof ApiScreeningTestCase
     */
    screeningListType: ApiSanctionType;
}

/**
* @export
* @enum {string}
*/
export enum ApiScreeningTestCaseScreenableTextTypeEnum {
    NAME = 'NAME',
    PAYMENT_REFERENCE = 'PAYMENT_REFERENCE',
    BANK_NAME = 'BANK_NAME',
    BIC = 'BIC',
    NAME_REFERENCE = 'NAME_REFERENCE'
}


/**
 * Check if a given object implements the ApiScreeningTestCase interface.
 */
export function instanceOfApiScreeningTestCase(value: object): value is ApiScreeningTestCase {
    if (!('screenableText' in value) || value['screenableText'] === undefined) return false;
    if (!('screenableTextType' in value) || value['screenableTextType'] === undefined) return false;
    if (!('screeningListType' in value) || value['screeningListType'] === undefined) return false;
    return true;
}

export function ApiScreeningTestCaseFromJSON(json: any): ApiScreeningTestCase {
    return ApiScreeningTestCaseFromJSONTyped(json, false);
}

export function ApiScreeningTestCaseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiScreeningTestCase {
    if (json == null) {
        return json;
    }
    return {
        
        'screenableText': json['screenableText'],
        'screenableTextType': json['screenableTextType'],
        'screeningListType': ApiSanctionTypeFromJSON(json['screeningListType']),
    };
}

export function ApiScreeningTestCaseToJSON(json: any): ApiScreeningTestCase {
    return ApiScreeningTestCaseToJSONTyped(json, false);
}

export function ApiScreeningTestCaseToJSONTyped(value?: ApiScreeningTestCase | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'screenableText': value['screenableText'],
        'screenableTextType': value['screenableTextType'],
        'screeningListType': ApiSanctionTypeToJSON(value['screeningListType']),
    };
}

